import { render, staticRenderFns } from "./BidDeleted.vue?vue&type=template&id=ee62b45a&"
import script from "./BidDeleted.vue?vue&type=script&lang=js&"
export * from "./BidDeleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports